/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersPutOrderApplyResponseOrderConfirmContents
 */
export interface JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersPutOrderApplyResponseOrderConfirmContents {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersPutOrderApplyResponseOrderConfirmContents
     */
    contents?: string;
}

export function JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersPutOrderApplyResponseOrderConfirmContentsFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersPutOrderApplyResponseOrderConfirmContents {
    return JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersPutOrderApplyResponseOrderConfirmContentsFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersPutOrderApplyResponseOrderConfirmContentsFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersPutOrderApplyResponseOrderConfirmContents {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'contents': !exists(json, 'contents') ? undefined : json['contents'],
    };
}

export function JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersPutOrderApplyResponseOrderConfirmContentsToJSON(value?: JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersPutOrderApplyResponseOrderConfirmContents | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'contents': value.contents,
    };
}

